import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    data: {
        video: {},
        directory: {},
        event:{},
        thread: {}
    }
};

const slice = createSlice({
    name: "suggested",
    initialState,
    reducers: {
        getSuggestedStart: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        getSuggestedFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        getSuggestedSuccess: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            state.data[payload.type] = payload.data;
        }
    }
});
const {reducer, actions} = slice;
export const {
    getSuggestedFailure, getSuggestedStart, getSuggestedSuccess
} = actions;
export default reducer;